import { EventEmitter } from "events";

const eventEmitter = new EventEmitter();
console.log("emitter hitted ", eventEmitter);

export default eventEmitter;